namespace Ir.Components.Workbook.Widgets.Widget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: IWidget;
        error: KnockoutComputed<string>;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;
        this.error = ko.computed(function (this: IWidget) {
            if (this.result && this.result instanceof BaseResultVM) {
                return (this.result as BaseResultVM).error();
            }

            return null;
        }, this.widget);
    }
}